import { useEffect, useState } from "react";
import { Button, Col, Form, Modal, Row } from "react-bootstrap";
import { Formik } from "formik";
import { LabelWithValue } from "../../../document/components/label-with-value";
import { DepartmentService } from "../../../../services/lookup-data/department.service";
import { useQueryClient } from "@tanstack/react-query";
import { docDepartmentKeys } from "../document-department/hooks/use-doc-departments";
import { CreateNotification } from "../../../../components/notifier";
import { useDocumentType } from "../../../document/hooks";
import { Select } from "antd";

const publicDepartmentStatus = [
  {
    label: "Đang sử dụng",
    value: 1,
  },
  {
    label: "Chưa sử dụng",
    value: 2,
  },
];

const EditDepartmentDetailModal = (props: any) => {
  const { onClose, isOpen, isUrl, data } = props;
  const [titleForm, setTitleForm] = useState<string>();
  const [saveLabel, setSaveLabel] = useState<string>();
  const queryClient = useQueryClient();
  const { data: docTypeData } = useDocumentType();

  const handleOnSubmit = async (values: any) => {
    const fields = {
      CompanyLookupId: data.CompanyId,
      Title: values.name,
      Abbr: values.abbr,
      DeptCode: values.deptCode,
      docType: JSON.stringify(values.docType),
      // Status: values.status
      Status: values.status,
    };

    data.Id ? await DepartmentService.update(data.Id, fields) : await DepartmentService.create(fields);
    queryClient.invalidateQueries({ queryKey: [docDepartmentKeys.all] });
    CreateNotification({
      title: "Thông báo",
      body: `${saveLabel} thành công !`,
      icon: "/icons/success.png",
    });
    onClose();
  };

  useEffect(() => {
    let titleFormLocal: string = "";
    if (data) {
      if (data.CompanyId) {
        titleFormLocal = data.Id ? "Chỉnh sửa đơn vị ban hành" : "Thêm đơn vị ban hành";
      } else {
        titleFormLocal = data.Id ? "Chỉnh sửa công ty" : "Thêm công ty";
      }

      setSaveLabel(data.Id ? "Cập nhật" : "Thêm");

      setTitleForm(titleFormLocal);
    }
  }, [data]);

  return (
    <Modal show={isOpen} onHide={onClose} centered size={isUrl ? "lg" : "xl"} className="edit-department-detail-modal">
      <Formik
        onSubmit={handleOnSubmit}
        initialValues={{
          name: data?.Name || "",
          abbr: data?.Abbr || "",
          deptCode: data?.DeptCode || "",
          docType: data?.docType || "",
          status: data?.Status || null,
          //status: { value: data?.Status, label: data?.Status },
          //publicStatus: publicDepartmentStatus?.length > 0 ? publicDepartmentStatus[0].value: null
        }}
      >
        {({ handleSubmit, setFieldValue, handleChange, isValid, values, errors }) => (
          <Form noValidate onSubmit={handleSubmit}>
            <Modal.Header closeButton>
              <Modal.Title>{titleForm}</Modal.Title>
            </Modal.Header>
            <Modal.Body className="py-4 px-4">
              <Form.Group as={Row} controlId="validationCustom01">
                <Col xs={2}>
                  <LabelWithValue label={"Tên"} value={""} required />
                </Col>
                <Col xs={10}>
                  <Form.Control
                    type="text"
                    placeholder=""
                    name="name"
                    value={values.name}
                    onChange={handleChange}
                    isInvalid={!!errors.name}
                    required
                  />
                  <Form.Control.Feedback type="invalid">{errors.name}</Form.Control.Feedback>
                </Col>
              </Form.Group>

              <Form.Group as={Row} controlId="validationCustom02">
                <Col xs={2}>
                  <LabelWithValue label={"Mã hiệu"} value={""} required />
                </Col>
                <Col xs={10}>
                  <Form.Control
                    type="text"
                    placeholder=""
                    name="deptCode"
                    value={values.deptCode}
                    onChange={handleChange}
                    isInvalid={!!errors.deptCode}
                  />
                  <Form.Control.Feedback type="invalid">{errors.deptCode}</Form.Control.Feedback>
                </Col>
              </Form.Group>

              <Form.Group as={Row} controlId="validationCustom02">
                <Col xs={2}>
                  <LabelWithValue label={"Tên viết tắt"} value={""} />
                </Col>

                <Col xs={10}>
                  <Form.Control
                    type="text"
                    placeholder=""
                    name="abbr"
                    value={values.abbr}
                    onChange={handleChange}
                    isInvalid={!!errors.abbr}
                  />
                  <Form.Control.Feedback type="invalid">{errors.abbr}</Form.Control.Feedback>
                </Col>
              </Form.Group>

              <Form.Group as={Row}>
                <Col xs={2}>
                  <LabelWithValue label={"Loại tài liệu"} value={""} />
                </Col>
                <Col xs={10}>
                  <Select
                    mode="multiple"
                    options={docTypeData}
                    value={values.docType || []}
                    onChange={(data) => {
                      setFieldValue("docType", data);
                    }}
                    className="custom-select-container py-0 w-full"
                  />
                </Col>
              </Form.Group>

              <Form.Group as={Row}>
                <Col xs={2}>
                  <LabelWithValue label={"Tình trạng"} value={""} />
                </Col>
                <Col xs={10}>
                  <Select
                    options={publicDepartmentStatus}
                    value={values.status}
                    onChange={(data) => {
                      setFieldValue("status", data);
                    }}
                    className="custom-select-container py-0 w-full"
                  />
                </Col>
              </Form.Group>
            </Modal.Body>
            <Modal.Footer>
              <Button onClick={onClose} variant="secondary">
                Đóng
              </Button>
              <Button disabled={!isValid} type="submit" variant="info">
                {saveLabel}
              </Button>
            </Modal.Footer>
          </Form>
        )}
      </Formik>
    </Modal>
  );
};

export default EditDepartmentDetailModal;
